export default function EFBattery() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 33.7498C10 35.1305 11.1193 36.2498 12.5 36.2498H27.5C28.8807 36.2498 30 35.1305 30 33.7498L30 8.74984C30 7.36912 28.8807 6.24984 27.5 6.24984L24.1654 6.24984V5.00114C24.1654 4.08066 23.4192 3.33447 22.4987 3.33447L17.4987 3.33447C16.5782 3.33447 15.832 4.08066 15.832 5.00114V6.24984L12.5 6.24984C11.1193 6.24984 10 7.36912 10 8.74984L10 33.7498ZM21.5 10.9989V8.33284H18.5V10.9989L15.834 10.9989L15.834 13.9989H18.5V16.6662H21.5L21.5 13.9989H24.1673V10.9989L21.5 10.9989ZM24.1654 29.0828L15.832 29.0828V32.0828H24.1654L24.1654 29.0828Z"
                fill="white"
            />
        </svg>
    );
}
